import profileApi from 'services/api/profile';
import UtilActions from 'utils/redux/Actions';
import UserActions from 'actions/UserActions';
import paymentUtils from 'utils/payment';

const getCreditCardsFromProfile = profileId => dispatch => {
    profileApi
        .getCreditCardsFromProfile(profileId)
        .then(data => {
            dispatch(UtilActions.merge('order', 'paymentOptions', data));
        })
        .catch(error => {
            //eslint-disable-next-line no-console
            console.error(error);
            throw error;
        });
};

const removeDefaultPaymentFromProfile = defaultPayment => (dispatch, getState) => {
    const profileId = getState().user.profileId;

    return profileApi
        .removeDefaultPaymentFromProfile(profileId, defaultPayment)
        .then(() => {
            dispatch(getCreditCardsFromProfile(profileId));

            // `toggleSelectAsDefaultPayment` is an XOR — dispatching it when the
            // checkbox was checked purely via the profile default (session flag
            // still empty) would flip the flag ON and re-check the box after the
            // uncheck click. Only fire it when it will actually clear an
            // in-session selection. Normalize both sides to bridge the
            // `PAY_PAL` vs `paypal` casing skew.
            const currentSelected = paymentUtils.normalizePaymentName(getState()?.user?.selectedAsDefaultPaymentName);
            const removed = paymentUtils.normalizePaymentName(defaultPayment);

            if (currentSelected === removed) {
                dispatch(UserActions.toggleSelectAsDefaultPayment(defaultPayment));
            }
        })
        .catch(error => {
            //eslint-disable-next-line no-console
            console.error(error);
            throw error;
        });
};

const addDefaultPaymentToProfile = defaultPayment => dispatch => {
    profileApi
        .addDefaultPaymentToProfile(defaultPayment)
        .then(() => {
            dispatch(UserActions.toggleSelectAsDefaultPayment(defaultPayment));
        })
        .catch(error => {
            //eslint-disable-next-line no-console
            console.error(error);
            throw error;
        });
};

export default {
    getCreditCardsFromProfile,
    removeDefaultPaymentFromProfile,
    addDefaultPaymentToProfile
};
